<script lang="ts" setup>
import {Contact, ContactGroup} from '@/models/dto/ContactGroup'
import ContactListItem from '@/components/Contact/ContactListItem.vue'
import {computed} from "vue";
import { getRoleLabelByKey } from '@/utils/urmUtils';
import { URMRoleKey } from '@/models/dto/userRoleManagement';
import sortBy from 'lodash/sortBy';

const emit = defineEmits(['refresh', 'click:delete-contact', 'update:contact', 'click:edit-contact', 'update:input', 'click:delete-contact'])

const props = withDefaults(defineProps<{
  contactGroups: ContactGroup[]
  hideEdit?: boolean
  isLoading?: boolean
  reservationId?: number
  hideDelete?: boolean
  alignLeft?: boolean
}>(), {
  hideEdit: false,
  isLoading: false,
  hideDelete: false,
  alignLeft: true
})

const sortedContactGroups = computed(() => {
     return props.contactGroups.map(group => {
       const sortedContacts = sortBy(group.contacts, contact => (contact.name || contact.email || '').toLowerCase());
       return {
         ...group,
         contacts: sortedContacts,
       };
     });
   });

const groupKeyToLabel = (groupKey: string): string => {
  return getRoleLabelByKey(groupKey)
}

const onContactEditClick = (contact: Contact) => {
    emit('click:edit-contact', contact)
}

const onDeleteContactClick = (contact: Contact) => {
  emit('click:delete-contact', contact)
}
</script>

<template>
  <div>
    <v-progress-circular
      v-if="isLoading"
      indeterminate
      color="primary"
      class="my-4"
    />
    <template v-else>
      <div class="margin-t-4">
        <div
          v-for="(contactGroup, contactGroupIndex) in sortedContactGroups"
          :id="`contact-group-${contactGroup.groupKey}-${contactGroupIndex}`"
          :key="`contact-group-${contactGroup.groupKey}-${contactGroupIndex}`"
        >
          <h4 class="font-book font-14 text-gray-light">{{ groupKeyToLabel(contactGroup.groupKey) }}</h4>
          <ContactListItem
            v-for="(contact, contactIndex) in contactGroup.contacts"
            :id="`contact-group-${contactGroup.groupKey}-${contactGroupIndex}-item-${contactIndex}`"
            :key="`contact-group-${contactGroup.groupKey}-${contactGroupIndex}-item-${contact.externalId}-${contactIndex}`"
            :align-left="alignLeft"
            :is-booking-contact="contactGroup.groupKey === URMRoleKey.TripBookingUser"
            :editable="contact.currentUserPermissions.canModifyContact && !hideEdit"
            :class="{ 'margin-b-2': contactIndex === contactGroup.contacts.length - 1 }"
            :contact="contact"
            @edit="onContactEditClick(contact)"
            @delete:contact="onDeleteContactClick(contact)"
            :hide-delete="hideDelete"
          />
        </div>
      </div>
    </template>
  </div>
</template>
